import { AnyAction } from 'redux'
import { createAction } from 'redux-actions'
import { ThunkDispatch } from 'redux-thunk'
import { message } from 'antd'
import { RootState } from '../../reducers'
import { isHasBasicInfo } from '../../../javascripts/generic'
import { actionLogoutSuccess } from '../user'
import { ExamineeService, ListExamineesRequest } from '../../../api/sennotech/scanner/v2/examinee'
import { post, url } from '../../../javascripts/http'
import i18n from '../../../i18n'
import { Language } from '../../../api/sennotech/scanner/v2/type'
import { ObjectStorageService } from '../../../api/sennotech/scanner/v2/object_storage'
import { ExaminationService } from '../../../api/sennotech/scanner/v2/examination'

var COS = require('cos-js-sdk-v5');

const examineeService = new ExamineeService(url, post);
const objectStorageService = new ObjectStorageService(url, post);
const examinationService = new ExaminationService(url, post);

export function actionGetExamineeList (data) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return ;
        }
        message.loading(i18n.t("dataLoading"), 0);
        try {

            let orgId = getState().user.orgId;
            let reqData: ListExamineesRequest = {
                storeId: +orgId,
                pageNum: data.pageNum - 1,
                pageSize: data.pageSize,
            }
            if(data.nickname) {
                reqData.nickname = data.nickname;
            }
            let res = await examineeService.listExaminees(reqData);
            let examineeIds = res.examinees.map((item) => {
                return item.id;
            })
            let res_detect = await examinationService.batchGetReportInfos({
                examineeIds: examineeIds
            })
            let reportInfo = res_detect.reportInfo || [];
            if(reportInfo.length) {
                res.examinees = res.examinees.map((item) => {
                    let detect = reportInfo.find((d) => {
                        return d.examineeId === item.id;
                    }) || {};
                    return {
                        ...item,
                        ...detect,
                        examineeId: item.id,
                    }
                })
            }

            dispatch(actionGetExamineeListSuccess({
                data: res
            }))

            message.destroy();
        } catch (error) {
            message.error(i18n.t('dataLoadFail'), 0);
        }
    }
}

export const ACTION_GETEXAMINEELIST_SUCCESS = "SILIZHU.GETEXAMINEELIST_SUCCESS"

export interface ActionGetExamineeListPayload {
    data: any
}

export const actionGetExamineeListSuccess = createAction(
    ACTION_GETEXAMINEELIST_SUCCESS,
    (payload: ActionGetExamineeListPayload) => {
        return payload;
    }
)


export function actionGetExamineeExcelTemplate () {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return ;
        }
        try {

            let res = await examineeService.getExamineeExcelTemplate({
                language: i18n.language === "en" ? Language.EN : Language.ZH
            });

            dispatch(actionGetExamineeExcelTemplateSuccess({
                data: res.url
            }))

            message.destroy();
        } catch (error) {
            message.error(i18n.t('dataLoadFail'), 0);
        }
    }
}

export const ACTION_GETEXAMINEEEXCELTEMPLATE_SUCCESS = "SILIZHU.GETEXAMINEEEXCELTEMPLATE_SUCCESS"

export interface ActionGetExamineeExcelTemplatePayload {
    data: any
}

export const actionGetExamineeExcelTemplateSuccess = createAction(
    ACTION_GETEXAMINEEEXCELTEMPLATE_SUCCESS,
    (payload: ActionGetExamineeExcelTemplatePayload) => {
        return payload;
    }
)

async function uploadCos(file) {
    let time = new Date().getTime();
    const type = file.name.substring(file.name.lastIndexOf("."));
    let filename = `/examinee-${time}.${type}`;
    let res = await objectStorageService.listKeyPrefixes({});
    let prefix = res.prefixes.find((item) => {
        return item.name === "TEMPORARY"
    }) || {};
    if(!prefix.hasOwnProperty("name")) return;
    let res_cos = await objectStorageService.getCosStsCredential({
        prefix
    } as any)

    let expireTime = (new Date(res_cos.expireTime as any)).valueOf();
    let expirationTime = +(expireTime || 0) / 1000;
    var cos = new COS({
        getAuthorization: function(options, callback) {
            callback({
                TmpSecretId: res_cos.tmpSecretId,
                TmpSecretKey: res_cos.tmpSecretKey,
                XCosSecurityToken: res_cos.sessionToken,
                ExpiredTime: expirationTime, // 时
            });
        }
    });

    return new Promise((resolve, reject) => {
        cos.putObject({
            Bucket: res_cos.bucket,
            Region: res_cos.region,
            Key: res_cos.keyPrefix + filename,
            Body: file,
            onProgress: function (info) {
                let progress = JSON.stringify(info);
                console.log({ progress })
            }
        }, function(err, data) {

            console.log({data, err});
            if(err) {
                reject(err)
            }
            else {
                let filePath = `https://${data.Location}`
                resolve(filePath)
            }
        })
    })
}

export function actionImportExamineesFromExcel (file) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return ;
        }
        try {

            message.loading(i18n.t("uploading"), 0);

            let url = await uploadCos(file) as string;
            const orgId = getState().user.orgId;
            let res = await examineeService.importExamineesFromExcel({
                url: url,
                storeId: +orgId
            });
            
            dispatch(actionImportExamineesFromExcelSuccess({
                data: res
            }))

            message.destroy();
            message.success(i18n.t("uploadSuccessTip"), 10)
            setTimeout(() => {
                dispatch(actionGetExamineeList({
                    pageNum: 1,
                    pageSize: 10
                }))
            }, 120000)

        } catch (error) {
            message.error(i18n.t('uploadFail'), 5);
        }
    }
}

export const ACTION_IMPORTEXAMINEESFROMEXCEL_SUCCESS = "SILIZHU.IMPORTEXAMINEESFROMEXCEL_SUCCESS"

export interface ActionImportExamineesFromExcelPayload {
    data: any
}

export const actionImportExamineesFromExcelSuccess = createAction(
    ACTION_IMPORTEXAMINEESFROMEXCEL_SUCCESS,
    (payload: ActionImportExamineesFromExcelPayload) => {
        return payload;
    }
)

export function actionGetExamineeDetail (data) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}));
            return ;
        }
        message.loading(i18n.t("dataLoading"), 0);
        try {

            let res = await examineeService.getExaminee({
                id: data.examineeId,
            })
            let res_report = await examinationService.listReports({
                examineeId: data.examineeId,
                pageNum: data.pageNum - 1,
                pageSize: data.pageSize,
                language: i18n.language === "en" ? Language.EN : Language.ZH,
            })

            dispatch(actionGetExamineeDetailSuccess({
                data: {
                    examinee: res,
                    ...res_report
                }
            }))

            message.destroy();
        } catch (error) {
            message.error(i18n.t('dataLoadFail'), 0);
        }
    }
}

export const ACTION_GETEXAMINEEDETAIL_SUCCESS = "SILIZHU.GETEXAMINEEDETAIL_SUCCESS"

export interface ActionGetExamineeDetailPayload {
    data: any
}

export const actionGetExamineeDetailSuccess = createAction(
    ACTION_GETEXAMINEEDETAIL_SUCCESS,
    (payload: ActionGetExamineeDetailPayload) => {
        return payload;
    }
)